import React from 'react';
import './Services.css';
import lightsImage1 from '../assets/lights-style2-1.jpg';
import lightsImage2 from '../assets/lights-style2-2.jpg';
import lightsImage3 from '../assets/lights-style2-3.jpg';
import safetyImage from '../assets/man_installing_electrical_2.jpeg';

// Define service categories
const serviceCategories = [
  {
    id: 'preconstruction',
    title: 'PRE-CONSTRUCTION',
    image: lightsImage1,
    services: [
      'Cost Budgeting',
      'Coordination and Detailing',
      'Value Engineering'
    ]
  },
  {
    id: 'construction',
    title: 'CONSTRUCTION',
    image: lightsImage2,
    services: [
      'Project Supervision',
      'Field Coordination',
      'Value Engineering'
    ]
  },
  {
    id: 'design',
    title: 'DESIGN',
    image: lightsImage3,
    services: [
      'Lighting Design and Title 24',
      'Power Distribution',
      'Emergency Power/Back-up'
    ]
  },
  {
    id: 'additional',
    title: 'ADDITIONAL',
    image: safetyImage,
    services: [
      'Lighting Repair and Maintenance',
      'Power Monitoring',
      'Power Additions',
      'Troubleshooting'
    ]
  }
];

const Services: React.FC = () => {
  return (
    <section id="services" className="services-section section-alt">
      <div className="container">
        <div className="section-header">
          <h2>Services</h2>
          <p className="section-intro">
            TRI-BAY ELECTRIC, INC. works on both engineered and design/build projects.
            With our qualified team in place we can provide our customers with solutions and support
            throughout the entire construction process.
          </p>
        </div>

        <div className="services-grid">
          {serviceCategories.map((category) => (
            <div key={category.id} className="service-card">
              <div className="service-image-container">
                <img
                  src={category.image}
                  alt={`${category.title} services`}
                  className="service-image"
                />
                <div className="service-overlay">
                  <h3 className="service-title">{category.title}</h3>
                </div>
              </div>
              <div className="service-content">
                <ul className="service-list">
                  {category.services.map((service, index) => (
                    <li key={index} className="service-item">
                      <div className="service-bullet"></div>
                      {service}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 